import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  filterDrawerContainer: {
    background: 'gray',
    opacity: 0.5,
  },

  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    color: theme.palette.secondary.main,
    alignItems: 'center',
  },

  dropzoneText: {
    marginBottom: '8px',
    marginTop: '18px',
  },

  dropZone: {
    height: '100%',
    fullWidth: 'true',
  },

  loading_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    minHeight: '200px',
  },

  upload_container: {
    padding: '0 14px',
  },

  save_title_container: {
    padding: '0px 0px 6px 12px',
  },

  file_container: {
    display: 'flex',
  },

  file_name: {
    fontSize: theme.fonts.responsiveMedium,
  },

  accepted_files: {
    fontSize: theme.fonts.responsiveMedium,
    fontStyle: 'italic',
  },

  select_file_btn_container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '3%',
    justifyContent: 'center',
  },

  dropZone: { minHeight: '200px' },

  dropZone_hide: {
    display: 'none',
  },

  table_title_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '50px',
    maxHeight: '50px',
    margin: '4px',
    letterSpacing: '0.1rem',
  },

  table_title: {
    fontSize: theme.fonts.responsiveMediumBig,
    margin: '10px 0',
  },

  table_stats: {
    fontSize: theme.fonts.responsiveMedium,
  },

  table_row: {
    padding: '8px 2px',
    maxWidth: '10vw',
    overflow: 'hidden',
    whiteSpace: 'break-spaces',
    wordBreak: 'break-word',
  },

  grid_container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    minHeight: '30vh',
    maxHeight: '70vh',
    overflowY: 'auto',
  },

  tooltip_text: {
    letterSpacing: '0.1rem',
    textTransform: 'uppercase',
    fontSize: '12px',
  },

  save_filter_text: {
    letterSpacing: '0.1rem',
    padding: '6px',
    fontSize: theme.fonts.responsiveBig,
  },

  save_filter_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 0 20px 0',
  },

  textField: {
    width: '80%',
  },

  filter_container: {
    background: 'rgb(63 63 63)',
    padding: '8px',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'center',
    width: '60%',
  },

  row: {
    display: 'flex',
    width: '100%',
    marginBottom: '20px',
    gap: '10px',
  },

  column: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: '10px',
    gap: '20px',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '10px',
  },

  small_text_field: {
    '& .MuiInputBase-root': {
      height: '36px',
      fontSize: '0.813rem',
    },
    '& .MuiInputBase-input': {
      padding: '8px 14px',
      fontSize: '0.813rem',
    },
  },

  form_helper_text: {
    color: 'white',
    marginBottom: '4px',
    fontSize: theme.fonts.responsiveMedium,
    letterSpacing: '0.1rem',
  },

  action_button: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveMedium,
    margin: '8px',
    minWidth: '100px',
    padding: '2px 6px',
    backgroundColor: theme.palette.accents.dark,
    color: 'white',
    '&:hover': {
      background: theme.palette.accents.main,
      color: theme.palette.background.darkerBg,
    },
  },

  clear_action_button: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    fontWeight: 'bold',
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveMedium,
    margin: '8px',
    minWidth: '100px',
    padding: '2px 6px',
    color: '#d3d3d3',
    border: `1px solid #d3d3d3`,
    '&:hover': {
      background: theme.palette.accents.main,
      color: theme.palette.background.darkerBg,
      border: `1px solid ${theme.palette.accents.main}`,
    },
  },

  close_button: {
    color: theme.palette.primary.main,
  },

  draggable_title_container: {
    padding: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  save_title: {
    letterSpacing: '0.2rem',
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.primary.main,
  },

  exam_status: {
    fontSize: theme.fonts.responsiveMedium,
    fontStyle: 'italic',
  },

  status_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },

  table_placeholder: {
    color: 'gray',
    padding: '15%',
    fontStyle: 'italic',
    padding: '14px 10px 10px',
  },
  custom_filter_title: {
    marginBottom: '10px',
    fontSize: theme.fonts.responsiveBig,
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    letterSpacing: '0.1rem',
  },

  custom_filter_description: {
    marginBottom: '20px',
    fontSize: theme.fonts.responsiveMediumBig,
    color: theme.palette.text.secondary,
    letterSpacing: '0.1rem',
  },

  dropzone_text: {
    marginBottom: '20px',
    fontSize: theme.fonts.responsiveMediumBig,
    color: theme.palette.text.secondary,
    letterSpacing: '0.1rem',
  },

  dropzone_root: {
    background: 'rgb(63 63 63)',
    borderRadius: '5px',
    padding: '4px',
  },

  table_container: {
    maxHeight: '60vh',
    overflow: 'auto',
  },

  small_select: {
    '& .MuiOutlinedInput-root': {
      height: '36px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 14px',
      fontSize: '0.813rem',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1)',
      fontSize: '0.813rem',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    '& .MuiSelect-select': {
      paddingTop: '8px',
      paddingBottom: '8px',
    },
  },

  small_date_picker: {
    '& .MuiInputBase-root': {
      height: '36px',
      fontSize: '0.813rem',
    },
    '& .MuiInputBase-input': {
      padding: '8px 14px',
      fontSize: '0.813rem',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1)',
      fontSize: '0.813rem',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    '& .MuiInputAdornment-root': {
      height: '30px',
      '& .MuiIconButton-root': {
        padding: '4px',
      },
    },
    '.MuiSvgIcon-root': {
      height: '20px',
      width: '20px',
    },
  },
}));
